export const financialSelector = state => state.financialReducer;
